const identityDatashape = `
  ... on NationalIdType {
      type
      idCardNumber
      idCivilRegisterNumber
      idCivilRegisterPlace
      idFrontImage
      idBackImage
  }
      ... on PassportType {
      type
      passportNumber
      passportCivilRegisterNumber
      passportIssueCountry
      passportExpiryDate
      passportAttachment
  }

`;
export default identityDatashape;
